import React, { memo } from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
var cn = classnames.bind(styles);
var BLOCK_NAME = 'Skeleton';
export var Skeleton = memo(function () {
    return (React.createElement("div", { className: cn(BLOCK_NAME) },
        React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__header-line-container")) },
            React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__line"), "".concat(BLOCK_NAME, "__line--header-line--short")) })),
        React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__line")) }),
        React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__line")) }),
        React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__line")) }),
        React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__line")) }),
        React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__line")) }),
        React.createElement("div", { className: cn("".concat(BLOCK_NAME, "__line"), "".concat(BLOCK_NAME, "__line--short")) })));
});
